"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var deprecationWarning = exports.deprecationWarning = function deprecationWarning(message) {
  return console.warn("RMWC Deprecation Warning: " + message);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@rmwc/base/utils/deprecationWarning.js
// module id = 191
// module chunks = 0